module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("INTRODUCTION")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/s.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OR")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SOME")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PEOPLE,")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HISTORY")]), _vm._v(" is a series of stories devised by the mind to give one a sense of belonging to the community in which he or she lives. This is certainly true for me; I relish stories which create a sense of joy and that euphoria impels me to write about them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The true stories in this anthology were first written for "), _c('em', [_vm._v("Chicago Jewish History,")]), _vm._v(" published more or less quarterly by the Chicago Jewish Historical Society (CJHS) and this book is being published as part of a celebration of the 25th anniversary of the CJHS. As a practicing attorney since 1954, I have always been fascinated by history. I majored in English history at the University of Illinois (I identified with some of the English kings) and then researched and wrote about my family’s history in Germany, from which we fled in 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In 1987, after I chaired a CJHS panel discussion featuring a number of German Jewish refugees who had built new lives in Hyde Park, a community on Chicago’s South Side, I became interested in American history, and particularly in the history of Chicago Jews. My activities with CJHS grew and I was fortunate enough to be elected its president. Most of my time with CJHS was spent on research and writing for its newsletter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My research sources were the Regenstein Library at the University of Chicago, the Archives at the University of Illinois at Chicago, the Newberry Library, the Chicago Historical Society and, most of all, the Spertus Library, where, with the assistance of its librarian Dan Sharon (a brilliant source of information), I pored over old Chicago newspapers and many other books and magazines. The anchor work in my studies was H. L. Meites’ classic "), _c('em', [_vm._v("History of the Jews of Chicago,")]), _vm._v(" originally published in 1924 and reissued in 1994 by the CJHS.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('em', [_vm._v("Walter Roth")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("November, 2002")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a995d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Introduction.vue
// module id = 75
// module chunks = 0